<div fxFlex class="flex flex-row justify-between items-center"
     matTooltip="{{item.cells[fieldDefinition.key] && item.cells[fieldDefinition.key].value?.toolTip ? item.cells[fieldDefinition.key].value?.toolTip : ''}}">
  <a (click)="onClick()" [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
     [ngClass]="!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true' ? 'link-color' : 'disabled'"
     analyticsCategory="link-cell-viewer"
     class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis"
     particleAnalytics
  >
    <div class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis">
      <div class="ellipsis full-grow-no-shrink-no-basis" title="{{item.cells[fieldDefinition.key]?.displayText}}">
        {{item.cells[fieldDefinition.key]?.displayText}}
      </div>
    </div>
  </a>
  <div *ngIf="!item.cells['IsCustom'].value" class="flex flex-row justify-end items-center">
    <particle-dynamic-tooltip-container
      [component]="'DefaultTemplateTooltipComponent'"
      [metadata]="tooltipText">
      <i class="{{icon}}"></i>
    </particle-dynamic-tooltip-container>
  </div>
</div>
